import multiGuard from '@/router/utils/vue-router-multiguard'
import checkTokenGuard from '@/router/guards/check-token-guard'
import checkPaymentRedirection from '@/router/guards/check-payment-redirection'
import marketingGuard from '@/router/guards/marketing-guard'

export default [
  {
    path: '/payment',
    component: () => import(/* webpackChunkName: "payment-routes" */ '@/views/payment/PaymentLayout.vue'),
    beforeEnter: multiGuard([checkTokenGuard, checkPaymentRedirection, marketingGuard]),
    children: [
      {
        path: 'succeed',
        name: 'payment:succeed',
        component: () => import(/* webpackChunkName: "payment-routes" */ '@/views/payment/PaymentSucceedView.vue'),
        meta: {
          layout: 'full',
        },
      },
      {
        path: 'failed',
        name: 'payment:failed',
        component: () => import(/* webpackChunkName: "payment-routes" */ '@/views/payment/PaymentFailedView.vue'),
        meta: {
          layout: 'full',
        },
      },
    ],
  },
]
